<template>
<div class="pace">
  <h1 class="pace-n"></h1>
</div>
</template>

<script>

export default {
  name: 'loader',
  mounted() {
  }
}
</script>

<style scoped>
  .pace {
      position: fixed;
      z-index: 2000;
      top: 0;
      left: 0;
      height: 100vh;
      width: 100vw;
      background-color: #1e1e1e;

      -webkit-pointer-events: none;
      pointer-events: none;

      -webkit-user-select: none;
      -moz-user-select: none;
      user-select: none;
    }

    .pace-n
    {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      opacity: 0.2;
    }
</style>
